const orderStatus = [
    {
        statusName: 'Pending',
        statusID: '0',
    },
    {
        statusName: 'Processing',
        statusID: '1',
    },
    
    {
        statusName: 'Shipped',
        statusID: '2',
    },
    
    {
        statusName: 'Delivered',
        statusID: '3',
    },
    
    {
        statusName: 'Cancelled',
        statusID: '4',
    },
];

export default orderStatus;
